export const extractCaseDetails = data => ({
  searchTerm: data.searchTerm,
  assignedTo: data.assignedTo,
  assignedToId: data.assignedToId,
  year: data.year,
  attachedTo: data.attachedTo || [],
  fuzziness: data.fuzziness,
  dateOfBirth: data.dateOfBirth,
  runBy: data.runBy,
  created: data.created,
  countries: data.countries || '',
  caseStatus: data.caseStatus,
  onGoing: data.onGoing,
  entityType: data.entityType,
  pendingDeletion: data.pendingDeletion,
});
